import React from 'react';
import {connect} from "react-redux";
import {AppState} from "@Redux/store";
import {unitOrganisations} from "@Selectors/builder/myArmyList/minimal/unitOrganisations";
import Repeater from "@Utils/Repeater";
import {UnitOrganisationView} from "@Selectors/builder/myArmyList/minimal/view/UnitOrganisationView";
import classNames from "classnames";

const UnitOraganisationPoints: React.FC<UnitOraganisationPointsMakeProps> = ({unitOrganisation}) => {
  return <div className="organisation-points m-1">
    <h3 className="mt-1">{unitOrganisation.points} points</h3>
    <ul>
      <Repeater data={unitOrganisation.organisations} indexPrefix='organisation-point'>
        {
          (item: UnitOrganisationView) =>
            <li className={classNames({'p-1 p-md-2': true, 'highlight-red': !item.good})}><strong>{item.name}</strong> x{item.count}<em>{item.points} pts ({item.rate}%)</em></li>
        }
      </Repeater>
    </ul>

  </div>;
};

const mapStateToProps = (state: AppState) => {
  return {
    unitOrganisation: unitOrganisations(state)
  }
};

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(UnitOraganisationPoints);

type UnitOraganisationPointsMakeProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
